import { saveThenReturnAuthData } from "@modules/api/util/authHelper";

export const thunkAuthResponseCheckerSdk = async (
  fn: () => Promise<any>,
  rejectWithValue: (value: unknown) => any
) => {
  const response = await fn();

  if (response.success && response.data) {
    const data = response.data;

    return saveThenReturnAuthData(data);
  }

  return rejectWithValue(response.errors);
};
